/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportResponse } from '../models/ReportResponse';
import type { WbhReportRequest } from '../models/WbhReportRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReportControllerService {

  /**
   * Create report
   * @returns ReportResponse Report successfully created
   * @throws ApiError
   */
  public static createReport({
requestBody,
authorization,
}: {
requestBody: WbhReportRequest,
authorization?: string,
}): CancelablePromise<ReportResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/report',
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Unauthorized user`,
      },
    });
  }

}
